import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { FaUserCircle, FaCog, FaDownload, FaCopy } from 'react-icons/fa';
import './TextSummarization.css';
import './PdfUpload.css';
import { getTeachSummary } from '../../api/api';


//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

pdfjs.GlobalWorkerOptions.workerSrc =
  `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.js',
//   import.meta.url
// ).toString();



const TextSummarization = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [summary, setSummary] = useState('');
  const [loading, setLoading] = useState(false);

  const selectedLessonContent = location.state?.selectedLessons?.[0]?.content || '';
  const userEmail = 'Eezeelearn@gmail.com';
  //const { pdfUrl, pdfName, stepFlow = [], currentStepIndex = 0, fileName, selectedOptions = [], completedSteps = [] } = location.state || {};
  const { pdfUrl, pdfName, file, stepFlow, currentStep = [], currentStepIndex = 0, fileName, selectedOptions = [], completedSteps = [] } = location.state || {};


  const handleSignOut = () => {
    navigate(`/signin`);
  };
  {/*const handleExtract = async () => {
setLoading(true);
try {
const response = await getTeachSummary(selectedLessonContent, fileName || "lesson.txt");
setSummary(response.summary_text || "Summary generated."); 
} catch (err) {
console.error("Summarization error:", err);
setSummary("Failed to summarize.");
}
setLoading(false);
};*/}

  const handleExtract = async () => {
    setLoading(true);
    try {
      const response = await getTeachSummary(file);  // ✅ Pass File, not string
      setSummary(response.summary_text || "Summary generated.");
      setSummaries([{ title: "Teacher Explanation", summary: response.summary_text }]);  // ✅ Populate summaries
    } catch (err) {
      console.error("Summarization error:", err);
      setSummary("Failed to summarize.");
    }
    setLoading(false);
  };

  const [summaries, setSummaries] = useState([]);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    handleExtract(); // ✅ This triggers summarization
  }, []);

  const handleDownload = () => {
    const content = summaries.map(s => `${s.title}\n${s.summary}\n`).join('\n');
    const blob = new Blob([content], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'summary.txt';
    link.click();
  };

  const handleCopy = () => {
    const content = summaries.map(s => `${s.title}\n${s.summary}\n`).join('\n');
    navigator.clipboard.writeText(content).then(() => {
      alert('Summary copied to clipboard!');
    });
  };

  return (
    <div className="page-container">
      <div className="sidebar">
        <div className="sidebar-profile">
          <FaUserCircle className="sidebar-profile-icon" />
          <div className="sidebar-profile-name">{userEmail}</div>
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-item">My Projects</div>
          <div className="sidebar-item" onClick={() => navigate('/pdf-upload')}>New Project</div>
          <div className="sidebar-section">
            <div className="sidebar-item section-title">{pdfName || fileName || "Uploaded PDF"}</div>
            <div className="sidebar-submenu">
              <div className="sidebar-subitem enabled completed">PDF Upload</div>
              {stepFlow.map((step, index) => (
                <div
                  key={index}
                  className={`sidebar-subitem enabled ${completedSteps.includes(step) ? 'completed' : ''} 
          ${step === currentStep ? 'current-step' : ''} 
          enabled`}>
                  {step}
                </div>
              ))}
            </div>
          </div>
          <div className="sidebar-item">
            <FaCog style={{ marginRight: '8px' }} /> Settings
          </div>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>

      <div className="summary-layout">
        <div className="summary-panel">
          <div className="pdf-preview-section">

            {/*<Document file={pdfUrl} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                {Array.from(new Array(numPages), (el, index) => (
                  <Page pageNumber={1} width={800} />
                ))}
              </Document> */}
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title="PDF Preview"
                className="pdf-iframe"
              />
            ) : (
              <p>No PDF file specified.</p>
            )}
          </div>

          <div className="summary-section">
            <h3 className="summary-heading">Summarized Content</h3>
            <div className="summary-box">
              {summaries.map((item, index) => (
                <div key={index} className="summary-item">
                  <strong>{item.title}</strong>
                  <p>{item.summary}</p>
                </div>
              ))}
            </div>
            <div className="summary-actions">
              <button className="summary-btn" onClick={handleCopy}><FaCopy /> Copy</button>
              <button className="summary-btn" onClick={handleDownload}><FaDownload /> Download</button>
            </div>
          </div>
        </div>

        <div className="footer-buttons">
          <button className="action-btn" onClick={() => navigate(-1)}>Back</button>
          <button
            className="action-btn"
            onClick={() => navigate('/translation', {
              state: {
                selectedOptions,
                completedSteps,
                currentStep: '',
                stepFlow,
                fileName: pdfName || fileName,
                selectedLessons: summaries.map((s, i) => ({
                  title: s.title || `Lesson ${i + 1}`,
                  content: s.summary
                }))
              }
            })}
          >
            Next
          </button>

        </div>
      </div>
    </div>
  );
};

export default TextSummarization;
